import { printOneTimePassword } from '@app/dev/actions/terminal';
import Config from '@app/dev/config/main';
import { RESPONSE_CODES_ENUM } from '@app/dev/constants/enums/responseCodes';
import { getPopupDispatchers } from '@app/dev/contexts/popup';
import { getOriginalCpf } from '@app/dev/helpers/formatCpfNumber';
import { getSwarmSetRfidPinCodeRequest } from '@app/dev/helpers/terminalRequests/rfid';
import { store } from '@app/dev/index/terminalApp';
import { POPUPS } from '@common/constants/popups';
import { getAuthData } from '@common/helpers/auth';
import ToastWrapper from '@common/helpers/toastWrapper';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { validateCpf } from '@common/helpers/validateCpf';
import _ from 'lodash';

const createPlayerPin = async (form) => {
  const { openPopup } = getPopupDispatchers();

  try {
    const params = {
      PinCode: form.pin,
      Rfid: form.cpf.replaceAll('.', '').replaceAll('-', ''),
    };

    await swarmRequest(getSwarmSetRfidPinCodeRequest(params), 'betshop_command');

    openPopup(POPUPS.REGISTRATION_SUCCESS);
  } catch (ex) {
    ToastWrapper('error', ex.data);
  }
};

export const createTerminalPlayer = async (form, successPopupWithBenefits) => {
  const errors = {};
  const { openPopup } = getPopupDispatchers();

  if (Config.main.cpfType && !form.cpf) errors.cpf = 'Field is required';

  if (!_.isEmpty(errors)) return errors;

  try {
    const { token, currency } = getAuthData();

    let playerData = {
      FirstName: form.firstName,
      LastName: form.lastName,
      BirthDate: form.birthDate,
    };

    if (!Config.main.enableCpfAutoFill && Config.main.cpfType) {
      playerData = (await validateCpf(form.cpf))?.details;
    }

    if (typeof playerData !== 'object') return ToastWrapper('error', 'Client not found');

    const phoneNumber = form.customPhoneNumber ? `${form.customPhoneNumber.code?.replaceAll('+', '')}${form.customPhoneNumber.phone}` : form.phoneNumber;
    const rawPhoneNumber = typeof phoneNumber === 'object' ? `${phoneNumber.code?.replaceAll('+', '')}${phoneNumber.phone}` : phoneNumber;

    let login = Config.main.cpfType === 'cpfs' ? getOriginalCpf(form.cpf) : phoneNumber;

    if (Config.registrationFormConfigs.registrationUserName) {
      login = Config.registrationFormConfigs.registrationUserName === 'phoneNumber'
        ? rawPhoneNumber
        : form[Config.registrationFormConfigs.registrationUserName];
    }

    const userInfo = {
      MobileNumber: phoneNumber,
      Rfid: getOriginalCpf(form.cpf),
      CurrencyId: form.currency?.name || currency,
      PersonalId: getOriginalCpf(form.cpf),
      DocNumber: getOriginalCpf(form.cpf),
      FirstName: playerData.FirstName,
      LastName: playerData.LastName,
      BirthDate: playerData.BirthDate,
      Login: login,
      Password: form.password,
      Street: form.street,
      Country: form.country?.name || form.country,
      City: form.city,
      zipCode: form.zipCode,
    };

    if (form.email) userInfo.Email = form.email;

    const res = await swarmRequest({
      token,
      user_info: userInfo,
    }, 'terminal_create_player');

    switch (res.code) {
      case RESPONSE_CODES_ENUM.SUCCESS: {
        if (Config.main.cpfType === 'cpf') {
          await createPlayerPin(form);
          store.dispatch(printOneTimePassword(res.data.Password));
        } else if (successPopupWithBenefits) {
          openPopup(POPUPS.SUCCESS_POPUP_WITH_BENEFITS);
        }
        else {
          openPopup(POPUPS.SUCCESS_POPUP, {
            subTitle: 'Registration was Succesfull',
          });
        }
        break;
      }
      case RESPONSE_CODES_ENUM.DUPLICATE_IDENTIFICATOR: {
        ToastWrapper('error', 'Duplicate CPF');
        break;
      }
      default:
        ToastWrapper('error', res.data);
    }
  } catch (ex) {
    console.log(ex)
    ToastWrapper('error', ex.data);
  }

  return null;
};
